<template>
  <div class="box">
    <!--    医生注册-->
    <back v-if="!showSverlay" @change="$router.push({path: '/register'})"/>
    <div class="user-img">
      <img src="../../assets/login/illustration_staff_HCP@2x.png" alt="">
    </div>
    <div class="message">
      <span>请填写注册信息</span>
    </div>
    <div class="form">
      <van-cell-group class="input-box">
        <span class="xingxing">*</span>
        <van-field class="name" v-model="form.username" placeholder="请输入您的姓名"/>
      </van-cell-group>

      <van-cell-group class="chengshi input-box" @click="showSheet = true">
        <span class="xingxing">*</span>
        <span v-if="form.city === ''" class="placeholder-text">请选择您所在的城市</span>
        <span v-else class="xz-value">{{form.province}} {{form.city }}</span>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </van-cell-group>

      <van-cell-group class="chengshi input-box" @click="yyShow = true">
        <span class="xingxing">*</span>
        <span v-if="form.hospital === ''" class="placeholder-text">请选择您的医院</span>
        <span v-else class="xz-value">{{ form.hospital }}</span>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </van-cell-group>

      <van-cell-group class="chengshi input-box" @click="ksShow = true">
        <span class="xingxing">*</span>
        <span v-if="form.office === ''" class="placeholder-text">请选择您的科室</span>
        <span v-else class="xz-value">{{ form.office }}</span>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </van-cell-group>
      <van-cell-group class="chengshi input-box" @click="zcShow = true">
        <span class="xingxing">*</span>
        <span v-if="form.title === ''" class="placeholder-text">请选择您的职称</span>
        <span v-else class="xz-value">{{ form.title }}</span>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </van-cell-group>
      <div class="message-box">
        <p>如果您对拜耳影像学苑-在线学术沟通平台感兴趣，请留下您的手机号码，如需了解详情，<span @click="AIRep">点击这里</span></p>
      </div>
      <van-cell-group>
        <van-field class="name" v-model="form.mobile" placeholder="请输入您的手机号"/>
      </van-cell-group>
    </div>
    <!-- 所在城市   -->
    <van-action-sheet v-model="showSheet" :closeable="false">
      <van-area title="选择城市" :area-list="areaList" :columns-num="2" @cancel="cancel" @confirm="confirm"/>
    </van-action-sheet>
    <!--   科室 -->
    <ke-shi v-if="ksShow" @change="keshiChange"/>
    <!--    职称-->
    <zhi-cheng v-if="zcShow" @change="zhiChengChange"/>
    <!--    医院-->
    <hospital-list v-if="yyShow" @change="yiYuanChange"/>
    <div class="radio-box">
      <van-radio-group v-model="radio">
        <van-radio name="1">
          <span style="color: #333333;font-weight: 600">本人已阅读并接受</span>
          <span style="color: #0090C5;font-weight: 600"
                @click="$router.push({path: '/agreementDoctor'})">《个人信息披露知情同意》</span>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon"/>
          </template>
        </van-radio>
      </van-radio-group>
    </div>
    <!--    手动输入医院信息-->
    <open-input v-if="openInput" :inputType='inputType'  @change="openInputChange" @cancel="openInput = false"/> 
    <div class="save" @click="save">
      <span>注册</span>
    </div>
    <!--关注二维码-->
    <q-r v-show="showSverlay" :aiRepQrType="aiRepQrType"/>
  </div>
</template>

<script>
import ActiveIcon from '../../assets/login/icon_select@2x.png'
import InactiveIcon from '../../assets/login/icon_noselect@2x.png'
import Back from "@/components/back/Back";
import KeShi from "@/views/login/KeShi";
import ZhiCheng from "@/views/login/ZhiCheng";
import HospitalList from "@/views/login/HospitalList";
import QR from "@/views/login/QR";
import OpenInput from "@/views/login/OpenInput";
import { daQu } from '../../common/js/unit'

export default {
  name: "login2",
  components: {OpenInput, QR, KeShi, Back, ZhiCheng, HospitalList},
  
  data() {
    return {
      type:'new',
      inputType:'',
      openInput: false,
      showSverlay: false,
      aiRepQrType:'',
      areaList: {},
      elHeight: document.documentElement.clientHeight,
      radio: '',
      activeIcon: ActiveIcon,
      inactiveIcon: InactiveIcon,
      show: false,
      showSheet: false,
      ksShow: false,
      zcShow: false,
      yyShow: false,
      actions: [{name: '销售'}, {name: '非销售'}],
      zcActions: [{name: '销售'}, {name: '非销售'}],

      form: {
        hospital: '',
        title: '',
        office: '',
        province: '',
        city: '',
        username: '',
        mobile: '',
        region: '',
        openid: localStorage.getItem('openId'),
        unionId: localStorage.getItem('unionId'),
        avatar: localStorage.getItem('userImg-school'),
        type:'new',
        nickName:"",
      }
    }
  },
  created() {
    console.log(daQu('北京'));
    this.getArea()
    //获取用户信息 
		this.getUserInfo()

   let nickName= localStorage.getItem('nickName')
    const href = window.location.href
    if(href.indexOf('authStatus')>=0){
      let resultUrl=decodeURIComponent(href)
      let resultArray=resultUrl.split(",")

      resultArray.forEach(item=>{
        if(item.indexOf("nickname")>0){
         let nickName= item.split(":")[1]
         localStorage.setItem('nickName',nickName.substring(1,nickName.length-1))
         window.location.replace("https://radacademy-q.wechat.bayer.cn/bayer/#/login/doctor")
        }
      })
      

    }else if(nickName ==null){
    this.getauth()
    }

    

  },
  methods: {
   
    getQRType(newName){
      if(newName=='江苏省' || newName=='山东省'){
       this.aiRepQrType='1'
    }else if(newName=='贵州省'||newName=='福建省'||newName=='海南省'||newName=='云南省'||newName=='广西壮族自治区'){
      this.aiRepQrType='2'
    }else if(newName=='浙江省'||newName=='江西省'||newName=='安徽省'||newName=='上海市'){
      this.aiRepQrType='3'
   }else if(newName=='青海省'||newName=='西藏自治区'||newName=='甘肃省'||newName=='湖南省'||newName=='湖北省'||newName=='宁夏回族自治区'||newName=='四川省'){
    this.aiRepQrType='4'
   }else if(newName=='河南省'||newName=='广东省'){
    this.aiRepQrType='5'
   }else if(newName=='陕西省'||newName=='重庆市'||newName=='山西省'||newName=='新疆维吾尔自治区'||newName=='内蒙古自治区'){
    this.aiRepQrType='6'
   }else if(newName=='辽宁省'||newName=='河北省'||newName=='天津市'||newName=='吉林省'||newName=='北京市'||newName=='黑龙江省'){
    this.aiRepQrType='7'
   }
    },

    getauth(){
   let  url= encodeURIComponent("https://radacademy-q.wechat.bayer.cn/bayer/#/login/doctor")
    window.location.replace(
                    `https://wecomapi-q.bayer.cn/open/clientapps/wxauth/111?redirect_uri=${url}&result_type=encodeurl&scope=userinfo`
                )
  
    },
    getUserInfo(){
		console.log("判断是否是注册员工")
		let userId=localStorage.getItem('userId-school')
		if(userId){
      
			this.$http.get(this.$api.user.getInfo+"/"+userId).then((response) => {
				let{code,data}=response
				if(code===0){
          this.form.type='update'
					this.form=data
				}
			})
		}

	},
    AIRep() {
      this.$dialog.alert({
        title: '拜耳影像学苑-在线学术沟通平台',
        confirmButtonColor: '#0090C5',
        messageAlign: 'left',
        message: '三位一体，为您提供全方位学术支持通道：\n' +
            '\n' +
            '“拜耳影像学苑”微信公众号\n' +
            '1. 学术资料，包罗万象\n' +
            '2. 学术会议，尽收眼底\n' +
            '3. 医学工具，助力临床\n' +
            '\n' +
            '“拜耳影像学苑”学习型微信社群\n' +
            '1. 创新社群，学无止境\n' +
            '2. 高效互动，事半功倍\n' +
            '3. 因需制宜，形式丰富\n' +
            '\n' +
            '“拜耳影像学苑”学术助手\n' +
            '1. 专属私助，及时响应\n' +
            '2. 定期互动，知您所需\n' +
            '3. 活动定制，精益求精\n' +
            '\n' +
            '如果您希望得到以上学术服务，请留下手机号，我们的学术助手会尽快联系您！',
        theme: 'round-button',
      })
    },
    save() {
      if (!this.form.username) {
        this.$toast('请填写姓名')
        return
      }
      if (!this.form.city) {
        this.$toast('请选择城市')
        return
      }
      if (!this.form.hospital) {
        this.$toast('请选择医院')
        return
      }
      if (!this.form.office) {
        this.$toast('请选择科室')
        return
      }
      if (!this.form.title) {
        this.$toast('请选择职称')
        return
      }
      if (!this.radio) {
        this.$toast('请先同意协议')
        return
      }
      this.getQRType(this.form.province)
      this.form.nickName=localStorage.getItem('nickName')
      let params = {
        identity: 1,
        ...this.form,
      }
      this.$http.post(this.$api.user.regist, params).then(res => {
        let {code, data, message} = res
        if (code === 0) {
          this.$toast('注册成功')
          localStorage.setItem('userId-school', data)
          this.showSverlay = true
        } else {
          this.$toast(message)
        }
      })
    },
    keshiChange(e) {
      this.ksShow = false
      // if (val) {
      //   this.form.office = val.value
      // }
      if (e) {
        if (e.value) {
          this.form.office = e.value
        } else if (e.type==='openInput2') {
          // 手动输入
          this.openInput = true
          this.inputType='2'
          console.log(this.openInput)
        }
      }

    },
    yiYuanChange(e) {
      this.yyShow = false
      if (e) {
        if (e.value) {
          this.form.hospital = e.value
        } else if (e.type==='openInput1') {
          // 手动输入
          this.openInput = true
          this.inputType='1'
          console.log(this.openInput)
        }
      }
    },
    openInputChange(val) {
      // 接手手动输入医院结果
      console.log("shhhhhh");
      if(val.type==='1'){
        this.form.hospital = val.value
      }else if(val.type==='2'){
        this.form.office = val.value
      }else if(val.type==='3'){
        this.form.title = val.value
      }
    
      this.openInput = false
    },
    zhiChengChange(e) {
      this.zcShow = false
      if(e.value==='其他'){
        this.openInput = true
          this.inputType='3'
      }else{
        
      if (e) {
        this.form.title = e.value
      }
      }
     
    },
    cancel() {
      this.showSheet = false
    },
    confirm(e) {
      this.form.region = daQu(e[0].name)
      this.form.province = e[0].name || null
      this.form.city = e[1].name || null
      // e.forEach((item, index) => {
      //   if (index + 1 !== e.length) {
      //     this.form.city = this.form.city + item.name + '  '
      //   } else {
      //     this.form.city = this.form.city + item.name
      //   }
      // })
      this.showSheet = false
    },
    getArea() {
      let provinces = require('../../common/js/province.json')
      let cities = require('../../common/js/city.json')
      let areas = require('../../common/js/county.json')
      //最后将值赋给 对象
      this.areaList.province_list = provinces;
      this.areaList.city_list = cities;
      this.areaList.county_list = areas;
    },
    onSelect(item) {
      this.form.department = item.name
      this.show = false
    }
  },
//   watch:{
//     'form.province'(newName,oldName){
//       if(newName=='江苏省' || newName=='山东省'){
//        this.aiRepQrType='1'
//     }else if(newName=='贵州省'||newName=='福建省'||newName=='海南省'||newName=='云南省'||newName=='广西壮族自治区'){
//       this.aiRepQrType='2'
//     }else if(newName=='浙江省'||newName=='江西省'||newName=='安徽省'||newName=='上海市'){
//       this.aiRepQrType='3'
//    }else if(newName=='青海省'||newName=='西藏自治区'||newName=='甘肃省'||newName=='湖南省'||newName=='湖北省'||newName=='宁夏回族自治区'||newName=='四川省'){
//     this.aiRepQrType='4'
//    }else if(newName=='河南省'||newName=='广东省'){
//     this.aiRepQrType='5'
//    }else if(newName=='陕西省'||newName=='重庆市'||newName=='山西省'||newName=='新疆维吾尔自治区'||newName=='内蒙古自治区'){
//     this.aiRepQrType='6'
//    }else if(newName=='辽宁省'||newName=='河北省'||newName=='天津市'||newName=='吉林省'||newName=='北京市'||newName=='黑龙江省'){
//     this.aiRepQrType='7'
//    }
//   }
// }

}
</script>
<style lang="scss" scoped>
.input-box {
  font-size: 24px !important;
  position: relative;

  .xingxing {
    font-size: 26px !important;
    font-weight: bold;
    color: red;
    position: absolute;
    left: -20px;
    top: 20px;
  }
}

.message-box {
  width: 564px;
  text-align: left;
  color: #383838;
  font-size: 28px;
  margin-bottom: 20px;

  span {
    color: #0090C5;
    font-weight: 500;
  }
}

.xz-value {
  color: #333333;
  font-weight: 500;
}

.chengshi {
  color: #c8c9cc;
  font-size: 26px;
  display: flex;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  position: relative;

  i {
    position: absolute;
    right: 30px;
  }
}

::v-deep {
  .van-field__control {
    text-align: center;
  }

  .img-icon {
    width: 38px;
  }

  .van-cell {
    font-weight: bold;
    font-size: 14px;
    background: none;
    line-height: normal;
  }

  .moren {
    .van-cell--clickable {
      text-align: center !important;
    }

    .van-cell__title {
      color: #c8c9cc;
    }
  }

  input::-ms-input-placeholder {
    text-align: center;
  }

  input::-webkit-input-placeholder {
    text-align: center;
  }

  .van-cell-group {
    width: 300px;
    height: 40px;
    border-radius: 40px;
    margin-bottom: 40px;
  }

  .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
    border: none;
  }
}

.save {
  margin: 36px auto;
  font-size: 28px;
  color: #ffffff;
  font-weight: bold;
  line-height: 80px;
  width: 600px;
  height: 80px;
  background: #0090C5;
  border-radius: 40px;
}

.radio-box {
  display: flex;
  justify-content: center;
}

.box {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: #f5f5f5;
  padding-top: 80px;
  padding-bottom: 120px;

  .user-img {
    img {
      width: 100%;
    }
  }

  .message {
    margin-bottom: 36px;

    span {
      font-size: 28px;
      color: #0090C5;
      font-weight: 600;
    }
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
